import React from "react"
import { Box, Grid, Container, Heading } from "@theme-ui/components"
import ArticleThumb from "../articleThumb"

const ArticleCollection = ({ block, theme }) => {
  const { articles, title } = block
  return (
    <Box sx={{ pb: [4, 6], mt: [6] }}>
      <Container>
        <Heading
          as="h2"
          variant="h3"
          sx={{ mb: [3, 4], mt: 0, color: "primary", fontWeight: "400" }}
        >
          {title}
        </Heading>
        <Grid columns={[1, 2, 3]} gap={[4]}>
          {articles.map(article => (
            <ArticleThumb
              article={article}
              key={article.id}
              theme={theme}
              small
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default ArticleCollection
